import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import './styles/theme.css';
import NavbarComponent from './components/Navbar/Navbar';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import FAQ from './pages/FAQ/FAQ';
import { Routes, Route, useLocation } from 'react-router-dom';
import Contact from './pages/Contact/Contact';
import Footer from './components/Footer/Footer';
import React, { useEffect, useState, useCallback } from 'react';
import ContactFormPopup from './components/ContactFormPopup/ContactFormPopup';
import ContactFormStandalone from './components/ContactFormStandalone/ContactFormStandalone';
import ReportingAnalytics from './pages/Analytics/Analytics';
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';
import HIPAA from './pages/HIPAA/HIPAA';
import NotFound from './pages/NotFound/NotFound';
import ThankYou from './pages/ThankYou/ThankYou';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [contactPopupOpen, setContactPopupOpen] = useState(false);

  // Expose a global function to open the popup
  const openContactPopup = useCallback(() => setContactPopupOpen(true), []);
  const closeContactPopup = useCallback(() => setContactPopupOpen(false), []);

  // Attach to window for global access
  React.useEffect(() => {
    window.openContactPopup = openContactPopup;
    return () => { delete window.openContactPopup; };
  }, [openContactPopup]);

  return (
    <div className="App">
      <ScrollToTop />
      <NavbarComponent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/analytics" element={<ReportingAnalytics />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/hipaa" element={<HIPAA />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <ContactFormPopup open={contactPopupOpen} onClose={closeContactPopup}>
        <ContactFormStandalone onSubmitted={closeContactPopup} />
      </ContactFormPopup>
    </div>
  );
}

export default App;
